var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapInsertLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5795 10.4236C15.023 10.7526 15.1158 11.379 14.7867 11.8225L8.23979 20.6466L4.67275 16.1068C4.33154 15.6725 4.40697 15.0438 4.84125 14.7026C5.27552 14.3614 5.90417 14.4368 6.24539 14.8711L8.19423 17.3515L13.1805 10.6308C13.5096 10.1873 14.1359 10.0945 14.5795 10.4236Z",
    fill: "#1D1D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31563 4.31563C2.16041 6.47085 2.16041 9.96514 4.31563 12.1204C4.70616 12.5109 4.70616 13.1441 4.31563 13.5346C3.92511 13.9251 3.29194 13.9251 2.90142 13.5346C-0.0348475 10.5983 -0.0348475 5.83768 2.90142 2.90142C5.83768 -0.0348477 10.5983 -0.0348473 13.5346 2.90142C16.4708 5.83768 16.4708 10.5983 13.5346 13.5346C13.1441 13.9251 12.5109 13.9251 12.1204 13.5346C11.7298 13.144 11.7298 12.5109 12.1204 12.1204C14.2756 9.96514 14.2756 6.47085 12.1204 4.31563C9.96514 2.16041 6.47085 2.16041 4.31563 4.31563Z",
    fill: "#1D1D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21701 8.72522C8.49714 8.72522 8.72423 8.49813 8.72423 8.218C8.72423 7.93786 8.49714 7.71077 8.21701 7.71077C7.93688 7.71077 7.70979 7.93786 7.70979 8.218C7.70979 8.49813 7.93688 8.72522 8.21701 8.72522ZM8.21701 10.7252C9.60171 10.7252 10.7242 9.6027 10.7242 8.218C10.7242 6.8333 9.60171 5.71077 8.21701 5.71077C6.83231 5.71077 5.70979 6.8333 5.70979 8.218C5.70979 9.6027 6.83231 10.7252 8.21701 10.7252Z",
    fill: "#1D1D38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInsertLocation);
export default __webpack_public_path__ + "static/media/mapInsertLocation.be4c6010.svg";
export { ForwardRef as ReactComponent };